<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="tournament-back d-flex justify-content-start align-items-center">
          <a class="tournament-back-link cursor-pointer" @click="$router.back()">←</a>
          <div class="tournament-page-title">
            {{ $t('TOURNAMENT') }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="tournament-header">
          <div class="top-header">
            <div class="row">
              <div class="d-flex justify-content-end align-items-center">
                <span class="tournament-time">{{ tournament.time_left }}</span>
              </div>
            </div>
            <div class="row">
              <div class="tournament-content d-flex flex-column justify-content-center align-items-center">
                <div class="tournament-title">{{ tournament.name }}</div>
                <div class="tournament-prize">
                  <img src="@/assets/img/prize.png" width="30" height="20" :alt="tournament.name">
                  {{ tournament.prize }}
                </div>
                <div class="tournament-played">
                  {{ convertNumberToLangWise(tournament.subscriber_count) }}+ {{ $t('PARTICIPANTS_ARE_PLAYING') }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="played-btn"
                   :class="{'played-btn-disabled': ! tournament.has_quota || ! tournament.subscribed}"
                   :disabled="! tournament.has_quota || ! tournament.subscribed">
                <div class="played-title"
                     @click="openPlayModal = true;"
                     v-if="tournament.has_quota && tournament.subscribed">
                  <span>{{ $t('PLAY_NOW') }}</span>
                </div>
                <div class="played-title" v-else-if="tournament.has_quota && ! tournament.subscribed">
                  <span>{{ tournament.message }} </span>
                </div>
                <div class="played-title" v-else>
                  <span>{{ $t('YOU_CANT_PLAY_MORE') }} </span>
                  <span class="subtitle">{{ $t('PARTICIPATE_IN_OTHER_TOURNAMENTS') }}</span>

                </div>
                <!--                <div class="played-title"-->
                <!--                     @click="getPayment(tournament.id, 'tournament', true)"-->
                <!--                     v-else>-->
                <!--                  <span>{{ $t('PLAY') }} {{ convertNumberToLangWise(tournament.subscription_fee) }} {{ $t('BDT') }} </span>-->
                <!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RankingList :ranking-list="ranking" v-if="ranking.length" :tournament-id="tournamentId" :type="'tournament'"/>
    <PlayNoticeModal :modal-show="openPlayModal" :tournament="tournament" v-if="openPlayModal"/>
  </div>
</template>

<script>
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import RankingList from "@/views/components/RankingList";
import PlayNoticeModal from "@/views/components/PlayNoticeModal";

export default {
  name: "TournamentDetails",
  components: {
    Loader,
    RankingList,
    PlayNoticeModal,
  },
  data() {
    return {
      loaderActive: false,
      openPlayModal: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      tournament: [],
      ranking: [],
      tournamentId: this.$route.query.tournament_id,
    }
  },
  created() {
    this.emitter.on('play-modal-close-event', (evt) => {
      this.openPlayModal = evt.eventContent;
    });
    this.getTournamentDetails();
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },
    getTournamentDetails() {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/tournament/details', {tournament_id: this.tournamentId}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.tournament = response.data.tournament;
              this.ranking = response.data.ranking;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    getPayment(payment_id, payment_type, is_on_demand) {
      this.$router.push({
        path: '/payment-method',
        query: {payment_id: payment_id, type: payment_type, is_on_demand: is_on_demand}
      });
    },
  }
}
</script>

<style scoped>

</style>
